import { render, staticRenderFns } from "./AiAssistantTabV2026.vue?vue&type=template&id=62a18611&scoped=true"
import script from "./AiAssistantTabV2026.vue?vue&type=script&lang=js"
export * from "./AiAssistantTabV2026.vue?vue&type=script&lang=js"
import style0 from "./AiAssistantTabV2026.vue?vue&type=style&index=0&id=62a18611&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a18611",
  null
  
)

export default component.exports